import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/public-pooja-booking.css";

export default function PoojaSuccess() {
  const { state } = useLocation();
  const paid = state?.payment_status === "SUCCESS";
  return (
    <div className="pb-page">
      <div className="pb-success">
        <div className="pb-success-icon"><i className={`fa fa-${paid ? "check" : "clock-o"}`} /></div>
        <h1>{paid ? "Payment Successful" : "Payment Status Not Confirmed"}</h1>
        <p>{paid ? "Your payment has been verified and your booking is confirmed." : "Please check your payment status in My Pooja Bookings before paying again."}</p>
        <div className="pb-success-no"><small>Booking / Order Number</small><strong>{state?.order_no || "Unavailable"}</strong></div>
        {state?.total_amount != null && <h2>₹{Number(state.total_amount).toLocaleString("en-IN",{minimumFractionDigits:2})}</h2>}
        {paid && state?.razorpay_payment_id && <p>Payment ID: {state.razorpay_payment_id}</p>}
        <Link to="/my-pooja-bookings" className="pb-pay">My Pooja Bookings</Link>
      </div>
    </div>
  );
}
